var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.41,
    y1: 0.996,
    x2: 0.616,
    y2: 0.021,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0d47a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80d8ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.089,
    y1: 0.927,
    x2: 1.025,
    y2: 0.309,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 1.095,
    y1: 0.756,
    x2: 0.117,
    y2: -0.093,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.081,
    y1: 0.227,
    x2: 0.914,
    y2: 1.159,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.507,
    y1: 0.022,
    x2: 0.466,
    y2: 1.019,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.922,
    y1: 0.048,
    x2: -0.046,
    y2: 0.712,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 4.303,
    y1: 2.788,
    x2: 4.429,
    y2: 1.678,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 2.37,
    y1: 5.711,
    x2: 3.197,
    y2: 4.604,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 4.074,
    y1: 2.545,
    x2: 2.783,
    y2: 1.958,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 3.289,
    y1: 2.49,
    x2: 4.602,
    y2: 3.136,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 3.975,
    y1: 2.166,
    x2: 3.95,
    y2: 3.3,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 2.741,
    y1: 5.28,
    x2: 1.885,
    y2: 6.47,
    xlinkHref: "#a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.814 -340.269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.289,378.066c-.016.136-.032.269-.048.382.016-.113.032-.246.048-.382a36.933,36.933,0,0,0-27.633-24.446c.115.086.224.169.318.241-.094-.072-.2-.155-.318-.241a36.909,36.909,0,0,0-34.95,11.705c.121-.051.239-.1.341-.143-.1.041-.22.092-.341.143a36.857,36.857,0,0,0-7.366,36.147c.016-.137.032-.269.048-.382-.016.113-.032.245-.048.382a36.933,36.933,0,0,0,27.633,24.446c-.115-.086-.225-.169-.318-.241.093.072.2.155.318.241a36.906,36.906,0,0,0,34.949-11.706c-.12.052-.239.1-.34.144.1-.041.22-.092.34-.144a36.853,36.853,0,0,0,7.367-36.146Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.289,378.066a36.853,36.853,0,0,1-7.367,36.146c3.65-1.565,15.763-7.888,21.493-18.25a49.349,49.349,0,0,0-19.194-45.632C137.329,360.461,136.757,374.1,136.289,378.066Z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.415,395.962c-5.73,10.362-17.843,16.685-21.493,18.25a36.906,36.906,0,0,1-34.949,11.706c3.222,2.4,14.758,9.713,26.587,9.47A49.542,49.542,0,0,0,150.415,395.962Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.289,378.066c.468-3.967,1.04-17.605-5.068-27.736a49.547,49.547,0,0,0-49.152-6.18c11.829-.243,23.365,7.069,26.587,9.47A36.933,36.933,0,0,1,136.289,378.066Z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.34,401.472c-.469,3.967-1.04,17.605,5.068,27.735a49.544,49.544,0,0,0,49.152,6.181c-11.829.243-23.365-7.069-26.587-9.47A36.933,36.933,0,0,1,66.34,401.472Z",
    fill: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.34,401.472a36.857,36.857,0,0,1,7.366-36.147c-3.649,1.566-15.762,7.889-21.492,18.251a49.332,49.332,0,0,0,19.194,45.631C65.3,419.077,65.871,405.439,66.34,401.472Z",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.706,365.325a36.909,36.909,0,0,1,34.95-11.705c-3.222-2.4-14.758-9.713-26.587-9.47a49.54,49.54,0,0,0-29.855,39.426C57.944,373.214,70.057,366.891,73.706,365.325Z",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.364,393.884c-.06.092-.118.18-.17.255.052-.075.11-.163.17-.255A29.381,29.381,0,0,0,119.4,366.659c.052.1.1.2.141.284-.041-.084-.089-.182-.141-.284a29.355,29.355,0,0,0-29.032-4.105l.293.019-.293-.019a29.322,29.322,0,0,0-18.1,23.1c.061-.092.119-.18.171-.255-.052.075-.11.163-.171.255A29.383,29.383,0,0,0,83.23,412.879c-.051-.1-.1-.2-.14-.285.04.085.089.183.14.285a29.366,29.366,0,0,0,29.033,4.105l-.293-.019.293.019a29.316,29.316,0,0,0,18.1-23.1Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.364,393.884a29.316,29.316,0,0,1-18.1,23.1c3.154.184,14.022-.006,21.786-5.341a39.254,39.254,0,0,0,2.576-39.3C137.367,381.727,132.109,391.228,130.364,393.884Z",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.049,411.643c-7.764,5.335-18.632,5.525-21.786,5.341a29.366,29.366,0,0,1-29.033-4.105c1.439,2.855,7.046,12.162,15.549,16.2A39.411,39.411,0,0,0,134.049,411.643Z",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.364,393.884c1.745-2.656,7-12.157,6.261-21.538a39.415,39.415,0,0,0-32.775-21.884c8.5,4.035,14.11,13.342,15.548,16.2A29.381,29.381,0,0,1,130.364,393.884Z",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.264,385.654c-1.744,2.656-7,12.157-6.26,21.538a39.412,39.412,0,0,0,32.775,21.884c-8.5-4.035-14.11-13.342-15.549-16.2A29.383,29.383,0,0,1,72.264,385.654Z",
    fill: "url(#j)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.264,385.654a29.322,29.322,0,0,1,18.1-23.1c-3.154-.184-14.022.005-21.786,5.341A39.24,39.24,0,0,0,66,407.192C65.261,397.811,70.52,388.31,72.264,385.654Z",
    fill: "url(#k)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.366,362.554a29.355,29.355,0,0,1,29.032,4.105c-1.438-2.855-7.045-12.162-15.548-16.2a39.411,39.411,0,0,0-35.27,17.433C76.344,362.559,87.212,362.37,90.366,362.554Z",
    fill: "url(#l)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8fb868e4542b24f735871ec8e7bfd500.svg";
export { ForwardRef as ReactComponent };